import { EMPTY_OBJECT } from '../../../constants/common'
import { PressAction } from '../../Action'

import { NAV_ARROWS_CONTROL_STEP } from './NavArrowsControl.constants'

function NavArrowsControl({
  Component,
  NextAction = PressAction,
  PrevAction = PressAction,
  betweenButtonsContent,
  children,
  disabled,
  maxValue,
  minValue,
  nextActionProps: {
    disabled: nextActionDisabled,
    ...nextActionProps
  } = EMPTY_OBJECT,
  prevActionProps: {
    disabled: prevActionDisabled,
    ...prevActionProps
  } = EMPTY_OBJECT,
  step = NAV_ARROWS_CONTROL_STEP,
  value,
  onChange,
  ...componentProps
}) {
  /** @param {number} actionValue */
  function handleNextAction(actionValue) {
    const nextValue = actionValue + step

    if (nextValue !== actionValue) {
      onChange?.(nextValue)
    }
  }

  /** @param {number} actionValue */
  function handlePrevAction(actionValue) {
    const nextValue = actionValue - step

    if (nextValue !== actionValue) {
      onChange?.(nextValue)
    }
  }

  return (
    <Component {...componentProps}>
      <PrevAction
        {...prevActionProps}
        disabled={
          disabled ||
          prevActionDisabled ||
          (minValue != null && value - step < minValue) ||
          (maxValue != null && value - step > maxValue)
        }
        value={value}
        onAction={handlePrevAction}
      />
      {betweenButtonsContent}
      <NextAction
        {...nextActionProps}
        disabled={
          disabled ||
          nextActionDisabled ||
          (minValue != null && value + step < minValue) ||
          (maxValue != null && value + step > maxValue)
        }
        value={value}
        onAction={handleNextAction}
      />
      {children}
    </Component>
  )
}

export default NavArrowsControl
